module.exports = __webpack_public_path__ + "img/img3.5cca557f.jpg";